import React from 'react';

const steps = [
  {
    step: '01',
    title: 'Consult',
    description: "We start by understanding what you need covered — your business, your home, your family.",
  },
  {
    step: '02',
    title: 'Compare',
    description: "We work with Belize's insurers to compare coverage and pricing on your behalf.",
  },
  {
    step: '03',
    title: 'Support',
    description: 'We stay involved after the policy is bound, including support if you ever need to file a claim.',
  },
];

const WhyBroker = () => {
  return (
    <div className="bg-white py-24">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <div className="mb-12 text-center">
          <p className="text-base font-semibold tracking-wide text-gold">How We Work</p>
          <p className="mt-2 font-serif text-4xl font-semibold text-navy-dark">The Value of a Broker</p>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            As your broker, we work alongside Belize's insurers on your behalf — comparing coverage across the market so you get a policy suited to you, with support that continues long after it's issued.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 border border-gray-200 divide-y sm:divide-y-0 sm:divide-x divide-gray-200">
          {steps.map((item) => (
            <div key={item.step} className="p-8">
              <p className="text-sm font-semibold text-gold">{item.step}</p>
              <p className="mt-2 font-serif text-xl font-semibold text-navy-dark">{item.title}</p>
              <p className="mt-2 text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyBroker;
